"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/ScheduleTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');







var _phone = require('shared/services/phone');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _hooks3 = require('web/screens/Directory/TeamPage/hooks');






var _team = require('shared/selectors/team');
var _SmsPreview = require('web/components/SmsPreview');
var _Form = require('web/components/Form');


var _components = require('web/screens/Directory/TeamPage/components');
var _MessageForm = require('./MessageForm'); var _MessageForm2 = _interopRequireDefault(_MessageForm);
var _NoReplySection = require('./NoReplySection'); var _NoReplySection2 = _interopRequireDefault(_NoReplySection);
var _ScheduleSection = require('./ScheduleSection'); var _ScheduleSection2 = _interopRequireDefault(_ScheduleSection);
var _utils = require('./ScheduleSection/utils');





















const onOff = (isOn, isPaused) => isPaused
  ? _react2.default.createElement(_components.StatusPill, { tone: "paused", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Paused")
  : _react2.default.createElement(_components.StatusPill, { tone: isOn ? 'on' : 'off', __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}},  isOn ? 'On' : 'Off' )

const ScheduleTab = ({
  teamKey,
  orgName,
  phoneNumber,
  canEditReplies,
  isAutoReplyEnabled,
  onToggleAutoReply,
  onUpdateAutoReplyInfo,
  isBusyReplyEnabled,
  onToggleBusyReply,
  onUpdateBusyReplyInfo,
}) => {
  const autoReplyMessage = _hooks.useAppSelector.call(void 0, state => _team.selectTeamAutoReplyMessage.call(void 0, state, teamKey))
  const busyReplyMessage = _hooks.useAppSelector.call(void 0, state => _team.selectBusyReplyMessage.call(void 0, state, teamKey))
  const areTeamHoursSet = _hooks.useAppSelector.call(void 0, state => _team.selectAreTeamHoursSet.call(void 0, state, teamKey))
  const teamHoursList = _hooks.useAppSelector.call(void 0, state => _team.selectTeamHoursList.call(void 0, state, teamKey), _reactredux.shallowEqual)
  const timeZone = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_team.selectTeamByKey.call(void 0, state, teamKey), 'optionalAccess', _ => _.AutoReplyTimeZone]), () => ( null)))
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const isNoReplyOn = _hooks.useAppSelector.call(void 0, state => !!_optionalChain([_team.selectTeamByKey.call(void 0, state, teamKey), 'optionalAccess', _2 => _2.NoReply]))
  const { settings, isLoaded, loadFailed, saveNoReply } = _hooks3.useTeamReplySettings.call(void 0, teamKey)

  // One row open at a time; the preview follows it.
  const [openRow, setOpenRow] = _react.useState(isNoReplyOn ? 'noReply' : 'away')
  const [previewCase, setPreviewCase] = _react.useState('closed')
  const [draft, setDraft] = _react.useState(null)
  const toggleRow = (row) => {
    setOpenRow(open => open === row ? null : row)
    setDraft(null)
    if (row === 'away') setPreviewCase('closed')
    if (row === 'busy') setPreviewCase('open')
  }
  const closeRow = _react.useCallback.call(void 0, () => {
    setOpenRow(null)
    setDraft(null)
  }, [])
  const draftFor = _react.useCallback.call(void 0, 
    (row) => (text) =>
      setDraft(d => text === null ? (_optionalChain([d, 'optionalAccess', _3 => _3.row]) === row ? null : d) : { row, text }),
    [],
  )
  const [onDraftNoReply, onDraftAway, onDraftBusy] = _react.useMemo.call(void 0, 
    () => [draftFor('noReply'), draftFor('away'), draftFor('busy')],
    [draftFor],
  )
  const shown = (row, saved) => _optionalChain([draft, 'optionalAccess', _4 => _4.row]) === row && openRow === row ? draft.text : saved

  const handleSaveNoReply = _react.useCallback.call(void 0, 
    (isOn, message) => saveNoReply(isOn, message)
      .then(() => showSuccessBar(`No-reply mode has been ${isOn ? 'turned on' : 'turned off'}`))
      .catch(() => showWarningBar(`Failed to turn ${isOn ? 'on' : 'off'} no-reply mode`)),
    [saveNoReply, showSuccessBar, showWarningBar],
  )
  const [handleToggleAutoReply, onChangeAutoReplyMessage] = _react.useMemo.call(void 0, 
    () => [
      async (isOn) => onToggleAutoReply(isOn)
        .then(() => showSuccessBar(`Auto-reply has been ${isOn ? 'enabled' : 'disabled'}`))
        .catch(() => showWarningBar(`Failed to ${isOn ? 'enable' : 'disable'} auto-reply`)),

      async (autoReplyMessage) => onUpdateAutoReplyInfo({ autoReplyMessage })
        .then(() => showSuccessBar('Auto-reply message has been updated'))
        .catch(() => showWarningBar(`Failed to update auto-reply message`)),
    ],
    [onUpdateAutoReplyInfo, onToggleAutoReply, showWarningBar, showSuccessBar],
  )
  const [handleToggleBusyReply, onChangeBusyReplyMessage] = _react.useMemo.call(void 0, 
    () => [
      async (isOn) => onToggleBusyReply(isOn)
        .then(() => showSuccessBar(`Busy Reply has been ${isOn ? 'enabled' : 'disabled'}`))
        .catch(() => showWarningBar(`Failed to ${isOn ? 'enable' : 'disable'} Busy reply`)),

      async (BusyReplyMessage) => onUpdateBusyReplyInfo({ BusyReplyMessage })
        .then(() => showSuccessBar('Busy message has been updated'))
        .catch(() => showWarningBar(`Failed to update busy reply message`)),
    ],
    [onUpdateBusyReplyInfo, onToggleBusyReply, showWarningBar, showSuccessBar],
  )

  const hasBusyRow = isAutoReplyEnabled && areTeamHoursSet
  const hours = areTeamHoursSet
    ? [_utils.hoursSummary.call(void 0, teamHoursList), _utils.timezoneShort.call(void 0, timeZone)].filter(Boolean).join(' · ')
    : 'Not set'

  const phone = _phone.formatPhoneNumber.call(void 0, phoneNumber) || phoneNumber
  const noReplyText = shown('noReply', settings.NoReplyMessage)
  const awayText = shown('away', autoReplyMessage)
  const busyText = shown('busy', busyReplyMessage)
  const isBusyShown = hasBusyRow && isBusyReplyEnabled

  // No-reply also shows while it is being turned on, before Save.
  const showsNoReply = isNoReplyOn || (openRow === 'noReply' && _optionalChain([draft, 'optionalAccess', _5 => _5.row]) === 'noReply')
  const preview = showsNoReply ? (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "team-page--segmented team-page--segmented--single" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}, "Any time" )
      , _react2.default.createElement(_SmsPreview.SmsPhone, { from: `Text message from ${phone}`, isThread: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
        , _react2.default.createElement(_SmsPreview.SmsBubble, { side: "patient", className: "team-page--sample-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}},  _components.SAMPLE_TEXT )
        , _react2.default.createElement(_components.ReplyTag, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}, "No-reply mode" )
        , _react2.default.createElement(_SmsPreview.SmsBubble, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 152}},  noReplyText )
      )
    )
  ) : (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_components.Segmented, {
        label: "When the text arrives"   ,
        options: [{ value: 'open', label: 'Open' }, { value: 'closed', label: 'Closed' }],
        value: previewCase,
        onChange: setPreviewCase, __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}
      )
      , _react2.default.createElement(_SmsPreview.SmsPhone, { from: `Text message from ${phone}`, isThread: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}
        , _react2.default.createElement(_SmsPreview.SmsBubble, { side: "patient", className: "team-page--sample-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}},  _components.SAMPLE_TEXT )
        ,  previewCase === 'closed' && isAutoReplyEnabled && awayText && (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement(_components.ReplyTag, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 167}}, "Out-of-office reply" )
            , _react2.default.createElement(_SmsPreview.SmsBubble, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 168}},  awayText )
          )
        )
        ,  previewCase === 'open' && isBusyShown && busyText && (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement(_components.ReplyTag, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}, "In-office reply" )
            , _react2.default.createElement(_SmsPreview.SmsBubble, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 174}},  busyText )
          )
        )
      )
    )
  )

  const caption = showsNoReply
    ? 'Same reply day and night. Your hours-based replies are skipped.'
    : previewCase === 'closed'
      ? isAutoReplyEnabled
        ? 'Outside business hours, every text gets this reply.'
        : 'Out-of-office reply is off: texts outside business hours get no reply.'
      : isBusyShown
        ? 'During business hours, every text gets this reply.'
        : 'During business hours, texts get no reply. Your team answers from the inbox.'

  return (
    _react2.default.createElement(_components.TabFrame, { preview: preview, caption: caption, __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}}
      , _react2.default.createElement('div', { className: "team-page--status-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}
        , _react2.default.createElement(_components.StatusRow, {
          icon: '⏸️',
          title: "No-reply mode" ,
          status: onOff(isNoReplyOn, false),
          isOpen: openRow === 'noReply',
          onToggle: () => toggleRow('noReply'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}

          , _react2.default.createElement(_NoReplySection2.default, {
            isOn: isNoReplyOn,
            message: settings.NoReplyMessage,
            orgName: orgName,
            canEdit: canEditReplies && isLoaded,
            loadFailed: loadFailed,
            onSave: handleSaveNoReply,
            onClose: closeRow,
            onDraft: onDraftNoReply, __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}}
          )
        )
        , _react2.default.createElement(_components.StatusRow, {
          icon: '🕒',
          title: "Business hours" ,
          status: isNoReplyOn ? onOff(false, true) : _react2.default.createElement('span', { className: "team-page--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}},  hours ),
          isMuted: isNoReplyOn,
          isOpen: openRow === 'hours',
          onToggle: () => toggleRow('hours'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}

          , _react2.default.createElement(_ScheduleSection2.default, { teamKey: teamKey, onUpdateInfo: onUpdateAutoReplyInfo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}} )
        )
        , _react2.default.createElement(_components.StatusRow, {
          icon: '🌙',
          title: "Out-of-office reply" ,
          status: onOff(isAutoReplyEnabled, isNoReplyOn),
          isMuted: isNoReplyOn,
          isOpen: openRow === 'away',
          onToggle: () => toggleRow('away'),
          'data-testid': "team-page--out-of-office-message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 222}}

          , _react2.default.createElement(_Form.Toggle, {
            isChecked: isAutoReplyEnabled,
            onChange: handleToggleAutoReply,
            label: "Reply to texts outside business hours."     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}
          )
          , _react2.default.createElement(_MessageForm2.default, {
            message: autoReplyMessage,
            isDisabled: !isAutoReplyEnabled,
            onSave: onChangeAutoReplyMessage,
            onCancel: closeRow,
            onDraft: onDraftAway, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}
          )
        )
        ,  hasBusyRow && (
          _react2.default.createElement(_components.StatusRow, {
            icon: '💬',
            title: "In-office reply" ,
            status: onOff(isBusyReplyEnabled, isNoReplyOn),
            isMuted: isNoReplyOn,
            isOpen: openRow === 'busy',
            onToggle: () => toggleRow('busy'),
            'data-testid': "team-page--in-office-message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}}

            , _react2.default.createElement(_Form.Toggle, {
              isChecked: isBusyReplyEnabled,
              onChange: handleToggleBusyReply,
              label: "Reply to texts during business hours, when your team is busy."          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}
            )
            , _react2.default.createElement(_MessageForm2.default, {
              message: busyReplyMessage,
              isDisabled: !isBusyReplyEnabled,
              onSave: onChangeBusyReplyMessage,
              onCancel: closeRow,
              onDraft: onDraftBusy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}}
            )
          )
        )
      )
      ,  isNoReplyOn && (
        _react2.default.createElement('div', { className: "team-page--list-note", 'data-testid': "team-page--replies-paused", __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}, "Paused replies come back as they were when you turn no-reply mode off."

        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ScheduleTab)
